// Studyo Today Backend
// Package studyo.today.subscriptions.v1.resources
// Resource definitions
// Copyright (c) 2015-2021 Intuitic Inc.

// @generated by protoc-gen-es v2.2.5 with parameter "import_extension=js"
// @generated from file studyo/today/subscriptions/v1/resources/subscription_inactive_reason.proto (package studyo.today.subscriptions.v1.resources, syntax proto3)
/* eslint-disable */

import { enumDesc, fileDesc, tsEnum } from "@bufbuild/protobuf/codegenv1";

/**
 * Describes the file studyo/today/subscriptions/v1/resources/subscription_inactive_reason.proto.
 */
export const file_studyo_today_subscriptions_v1_resources_subscription_inactive_reason = /*@__PURE__*/
  fileDesc("CkpzdHVkeW8vdG9kYXkvc3Vic2NyaXB0aW9ucy92MS9yZXNvdXJjZXMvc3Vic2NyaXB0aW9uX2luYWN0aXZlX3JlYXNvbi5wcm90bxInc3R1ZHlvLnRvZGF5LnN1YnNjcmlwdGlvbnMudjEucmVzb3VyY2VzKqABChpTdWJzY3JpcHRpb25JbmFjdGl2ZVJlYXNvbhIsCihTVUJTQ1JJUFRJT05fSU5BQ1RJVkVfUkVBU09OX1VOU1BFQ0lGSUVEEAASKQolU1VCU0NSSVBUSU9OX0lOQUNUSVZFX1JFQVNPTl9QQVNUX0RVRRABEikKJVNVQlNDUklQVElPTl9JTkFDVElWRV9SRUFTT05fQ0FOQ0VMRUQQAkIvqgIsU3R1ZHlvLlRvZGF5LlN1YnNjcmlwdGlvbnMuR3JwYy5WMS5SZXNvdXJjZXNiBnByb3RvMw");

/**
 * Describes the enum studyo.today.subscriptions.v1.resources.SubscriptionInactiveReason.
 */
export const SubscriptionInactiveReasonSchema = /*@__PURE__*/
  enumDesc(file_studyo_today_subscriptions_v1_resources_subscription_inactive_reason, 0);

/**
 * Identifies why a subscription is inactive.
 *
 * @generated from enum studyo.today.subscriptions.v1.resources.SubscriptionInactiveReason
 */
export const SubscriptionInactiveReason = /*@__PURE__*/
  tsEnum(SubscriptionInactiveReasonSchema);

